"use strict";
/** state: Final **/
/** family: Dropdown **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Button_1 = require("../Button");
var Dropdown_1 = require("../Dropdown");
var DropdownItem_1 = require("../DropdownItem");
var utils_1 = require("../utils");
var DropdownButton = /** @class */ (function (_super) {
    __extends(DropdownButton, _super);
    function DropdownButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            _this.setState(function (prevState) { return ({
                isOpen: !prevState.isOpen,
            }); });
            _this.props.onClick && _this.props.onClick(e);
        };
        _this.handleClose = function () {
            if (_this.buttonRef) {
                _this.buttonRef.focus();
            }
        };
        /**
         * Inject `onClick` handler to DropdownItem children to close on click.
         */
        _this.injectPropsOnChildren = function () {
            return React.Children.map(_this.props.children, function (child) {
                if (utils_1.isType(child, DropdownItem_1.DropdownItem)) {
                    return React.cloneElement(child, {
                        onClick: function (e) {
                            _this.setState(function (prevState) { return ({
                                isOpen: !prevState.isOpen,
                            }); });
                            child.props.onClick && child.props.onClick(e);
                        },
                    });
                }
                return child;
            });
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    DropdownButton.prototype.UNSAFE_componentWillUpdate = function (nextProps, nextState) {
        if (this.state.isOpen !== nextState.isOpen) {
            nextProps.onToggle && nextProps.onToggle(nextState.isOpen);
        }
    };
    DropdownButton.prototype.componentDidUpdate = function (_, prevState) {
        if (!this.state.isOpen && prevState.isOpen) {
            this.handleClose();
        }
    };
    DropdownButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, id = _a.id, onClick = _a.onClick, onOutsideClick = _a.onOutsideClick, rightAlign = _a.rightAlign, role = _a.role, hideCaret = _a.hideCaret, restProps = __rest(_a, ["children", "className", "id", "onClick", "onOutsideClick", "rightAlign", "role", "hideCaret"]);
        return (React.createElement(Dropdown_1.Dropdown, { id: id, isOpen: this.state.isOpen, onOutsideClick: function (e) {
                _this.setState({ isOpen: false });
                if (onOutsideClick) {
                    onOutsideClick(e);
                }
            }, role: role, rightAlign: rightAlign, toggle: React.createElement(Button_1.Button, __assign({ "aria-expanded": this.state.isOpen.toString(), "aria-haspopup": true, buttonRef: function (el) { return (_this.buttonRef = el); }, className: classNames(className, {
                    'dropdown-toggle': !hideCaret,
                }), onClick: this.handleClick }, restProps)) }, role === Dropdown_1.Dropdown.Role.Menu
            ? this.injectPropsOnChildren()
            : children));
    };
    DropdownButton.Item = DropdownItem_1.DropdownItem;
    DropdownButton.Mode = Button_1.ButtonMode;
    DropdownButton.Role = Dropdown_1.DropdownRole;
    DropdownButton.defaultProps = {
        role: Dropdown_1.Dropdown.Role.Menu,
    };
    return DropdownButton;
}(React.Component));
exports.DropdownButton = DropdownButton;
//# sourceMappingURL=DropdownButton.js.map